
const validationIsraelyPhone = (str) => {
  var re = /^(\(?\+?[0-9]*\)?)?[0-9_\- ()]*$/;
  return re.test(str)&&str.length === 10&&str.startsWith("05");
};
export default validationIsraelyPhone;
